import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ApplicationState } from "../../../../store";
import bitdefenderIcons from "./bitdefender.json";
import defaultIcons from "./default.json";
interface IProps {
    iconName: string;
    color?: string;
    height?: string;
    width?: string;
}
function RenderIcons({ iconName, color, height, width }: IProps) {

    const isBitDefenderPartner = useSelector((state: ApplicationState) =>
        state.configurationState && state.configurationState.configuration.partnerConfig.partnerId
            ? state.configurationState.configuration.partnerConfig.partnerId === 2569
                ? true
                : false
            : false
    );
    const bitDefenderIcons: any = bitdefenderIcons;
    const defaultData: any = defaultIcons;

    let icon = defaultData[iconName];
    const domParser = new DOMParser();
    const parsedDoc = domParser.parseFromString(defaultData[iconName], 'text/html');
    let svgElement = parsedDoc.querySelector('svg');
    if (svgElement) {
        svgElement.setAttribute('role', 'img');
        svgElement.setAttribute('aria-label', iconName);
        icon = parsedDoc.documentElement.innerHTML;
    }

    const updateColor = (iconSvgString: string): string => {
        return iconSvgString
            ? iconSvgString
                .replaceAll(`fill='black'`, `fill=${!!color ? color : "#0f6aff "}`)
                .replaceAll(`stroke='black'`, `stroke=${!!color ? color : "#0f6aff "}`)
                .replace("height='32'", !!height ? `height=${height}` : "height='32'")
                .replace("width='32'", !!width ? `width=${width}` : "width='32'")
            : iconSvgString;
    };
    return isBitDefenderPartner ? (
        <em dangerouslySetInnerHTML={{ __html: updateColor(bitDefenderIcons[iconName]) }}></em>
    ) : (
        <em dangerouslySetInnerHTML={{ __html: icon }}></em>
    );
}

export default RenderIcons;
